import { NavBarSearchKeys } from "components/NavBarSearch/queryKeys";
import { typedQueryClient, useTypedQuery } from "hooks";

export const useSearchTerm = () => useTypedQuery({ queryKey: NavBarSearchKeys.searchTerm, initialData: "" }).data;

export const setSearchTerm = (searchTerm: string) => {
  (typedQueryClient.setQueryData(NavBarSearchKeys.searchTerm, searchTerm), 100, { leading: false, trailing: true });
};
